// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CollectorSettingsQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
}>;

export type CollectorSettingsQuery = {
  __typename?: "GraphqlQuery";
  getServerDetails: {
    __typename?: "Server";
    id: string;
    humanId: string;
    permittedToEdit: boolean;
    statementResetFrequency?: number | null;
    statementTimeoutMs?: number | null;
    statementTimeoutMsQueryText?: number | null;
    statementMaxSizeMb?: number | null;
    usesLocalCollector: boolean;
    dbName?: string | null;
    dbUsername?: string | null;
    dbHost?: string | null;
    dbPort?: number | null;
    dbSslmode?: string | null;
    dbUseIamAuth?: boolean | null;
    awsRegion?: string | null;
    awsDbInstanceId?: string | null;
    awsDbClusterId?: string | null;
    awsAssumeRole?: string | null;
    azureDbServerName?: string | null;
    azureSubscriptionId?: string | null;
    azureEventhubNamespace?: string | null;
    azureEventhubName?: string | null;
    azureAdClientId?: string | null;
    gcpCloudsqlInstanceId?: string | null;
    gcpAlloydbClusterId?: string | null;
    gcpAlloydbInstanceId?: string | null;
    gcpProjectId?: string | null;
    gcpPubsubSubscription?: string | null;
    enableLogs?: boolean | null;
    enableActivity?: boolean | null;
    filterLogSecret?: string | null;
    filterQuerySample?: string | null;
    filterQueryText?: string | null;
    systemType?: string | null;
    apiClusterId?: string | null;
    maxBufferCacheMonitoringGb?: string | null;
    ignoreSchemaRegexp?: string | null;
  };
};

export const CollectorSettingsDocument = gql`
  query CollectorSettings($serverId: ID!) {
    getServerDetails(serverId: $serverId) {
      id
      humanId
      permittedToEdit
      statementResetFrequency
      statementTimeoutMs
      statementTimeoutMsQueryText
      statementMaxSizeMb
      usesLocalCollector
      dbName
      dbUsername
      dbHost
      dbPort
      dbSslmode
      dbUseIamAuth
      awsRegion
      awsDbInstanceId
      awsDbClusterId
      awsAssumeRole
      azureDbServerName
      azureSubscriptionId
      azureEventhubNamespace
      azureEventhubName
      azureAdClientId
      gcpCloudsqlInstanceId
      gcpAlloydbClusterId
      gcpAlloydbInstanceId
      gcpProjectId
      gcpPubsubSubscription
      enableLogs
      enableActivity
      filterLogSecret
      filterQuerySample
      filterQueryText
      systemType
      usesLocalCollector
      apiClusterId
      maxBufferCacheMonitoringGb
      ignoreSchemaRegexp
    }
  }
`;

/**
 * __useCollectorSettingsQuery__
 *
 * To run a query within a React component, call `useCollectorSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectorSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectorSettingsQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *   },
 * });
 */
export function useCollectorSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CollectorSettingsQuery,
    CollectorSettingsQueryVariables
  > &
    (
      | { variables: CollectorSettingsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CollectorSettingsQuery,
    CollectorSettingsQueryVariables
  >(CollectorSettingsDocument, options);
}
export function useCollectorSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollectorSettingsQuery,
    CollectorSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CollectorSettingsQuery,
    CollectorSettingsQueryVariables
  >(CollectorSettingsDocument, options);
}
// @ts-ignore
export function useCollectorSettingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CollectorSettingsQuery,
    CollectorSettingsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CollectorSettingsQuery,
  CollectorSettingsQueryVariables
>;
export function useCollectorSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CollectorSettingsQuery,
        CollectorSettingsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CollectorSettingsQuery | undefined,
  CollectorSettingsQueryVariables
>;
export function useCollectorSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CollectorSettingsQuery,
        CollectorSettingsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CollectorSettingsQuery,
    CollectorSettingsQueryVariables
  >(CollectorSettingsDocument, options);
}
export type CollectorSettingsQueryHookResult = ReturnType<
  typeof useCollectorSettingsQuery
>;
export type CollectorSettingsLazyQueryHookResult = ReturnType<
  typeof useCollectorSettingsLazyQuery
>;
export type CollectorSettingsSuspenseQueryHookResult = ReturnType<
  typeof useCollectorSettingsSuspenseQuery
>;
export type CollectorSettingsQueryResult = Apollo.QueryResult<
  CollectorSettingsQuery,
  CollectorSettingsQueryVariables
>;
